import React, { Fragment } from 'react';
import { Popover as PopoverHeadlessui, Transition } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import { classNames } from '../common/utils/utils';

export interface PopoverItem<T> {
  icon?: React.ReactNode;
  label: string;
  onClick: (row: T) => void;
  alert?: boolean;
  primary?: boolean;
  itemId?: string;
}

interface PopoverProps<T> {
  row: T;
  items: PopoverItem<T>[];
  popoverId?: string;
  className?: string;
}

const Popover = <T extends object>({ row, items, popoverId, className }: PopoverProps<T>) => {
  return (
    <PopoverHeadlessui className="relative">
      {({ open, close }) => (
        <>
          <PopoverHeadlessui.Button
            id={popoverId}
            className={`${
              open ? 'text-cool-gray-900' : 'text-cool-gray-500'
            }  group bg-white rounded-md inline-flex items-center sm:text-sm lg:text-base text-xs font-medium hover:text-cool-gray-900 focus:outline-none h-full`}
          >
            <EllipsisVerticalIcon
              className={`${
                open ? 'text-cool-gray-600' : 'text-cool-gray-400'
              } h-6 w-6 group-hover:text-cool-gray-500`}
              aria-hidden="true"
            />
          </PopoverHeadlessui.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <PopoverHeadlessui.Panel
              className={classNames(
                className ? className : '',
                'absolute z-10 mt-2 px-0 w-44 sm:w-56 min-w-fit',
              )}
            >
              <div className="rounded-lg shadow-section overflow-hidden">
                <div className="bg-white">
                  {items.map(({ icon, label, onClick, alert, primary, itemId }) => (
                    <label
                      id={itemId}
                      className={classNames(
                        alert ? 'text-red' : primary ? 'text-green' : 'text-cool-gray-700 ',
                        'py-2 px-4 flex gap-1 items-center transition ease-in-out hover:bg-cool-gray-100 cursor-pointer',
                      )}
                      key={label}
                      onClick={() => {
                        onClick(row);
                        close();
                      }}
                    >
                      {icon}
                      <small>{label}</small>
                    </label>
                  ))}
                </div>
              </div>
            </PopoverHeadlessui.Panel>
          </Transition>
        </>
      )}
    </PopoverHeadlessui>
  );
};

export default Popover;
